import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { useMemo } from "react";

export const useModuleRoutePaths = ({ resource }: { resource: string }) => {
  return useMemo(
    () =>
      createModuleRoutePaths({
        resource,
      }),
    [resource],
  );
};
